<template>
  <div
    :class="{ 'bg-white shadow-sm rounded': standalone, 'flex-sm-row': !standalone }"
    class="p-3 d-flex justify-content-between flex-column position-relative"
  >
    <div>
      <p class="h5 mb-1">{{ title }}</p>
      <p class="text-muted text-sm mb-2">{{ description | truncate(150) }}</p>
      <div class="d-flex">
        <p v-if="standalone" class="text-dark h5 mb-0 mr-2">{{ price }}</p>
        <p v-if="duration" class="text-muted mb-0 d-flex align-items-center">
          <Clock class="svg-24 text-muted mr-1" /> {{ duration }}
        </p>
      </div>
    </div>
    <div :class="{ 'text-sm-center': !standalone }" class="mt-2">
      <p v-if="!standalone" class="text-dark h5 mb-2">{{ price }}</p>
      <ActionButton :href="link" variant="small" class="stretched-link">{{
        linkText
      }}</ActionButton>
    </div>
  </div>
</template>

<script>
import Clock from "../../icons/atalanda/clock-16.svg";
import ActionButton from "./ActionButton.vue";

export default {
  name: "ServiceTile",
  components: {
    Clock,
    ActionButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    price: {
      type: String,
      required: true,
    },
    duration: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      required: true,
    },
    linkText: {
      type: String,
      required: true,
    },
    standalone: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
